import { NgModule } from '@angular/core';
import { getFeatureEnabledGuard } from '@capital-access/common/feature-toggle';
import { CommonRouterModule } from '@capital-access/common/router';

export const loadModule = () => import('@capital-access/alerts/client').then(m => m.AlertsClientModule);

// @dynamic
@NgModule({
  imports: [
    CommonRouterModule.forFeature({
      authorized: [
        {
          path: 'data-alerts',
          loadChildren: loadModule,
          canActivate: [getFeatureEnabledGuard('CA-Alerts')]
        }
      ]
    })
  ]
})
export class AlertsClientLazyModule {}
